import React from 'react';
import { CardProps } from '../../components/request-a-quote-form/types';

const Card: React.FC<CardProps> = ({
  heading,
  errorHeading,
  copy,
  phone,
  linksHeading,
  firstLink,
  secondLink,
  submitError,
  errorLabel
}) => {
  return (
    <>
      {copy && !submitError && (
        <>
          <h2 className="request-a-quote__card-heading">{heading}</h2>
          <p
            className={`request-a-quote__card-copy${linksHeading ? '--ty' : ''}`}
          >
            {copy}
          </p>
        </>
      )}
      {errorLabel && submitError && (
        <>
        <h2 className="request-a-quote__card-heading error">
          {errorHeading ? errorHeading : heading}
        </h2>
        <div
          className={`request-a-quote__card-copy${linksHeading ? '--ty' : ''}`}
          dangerouslySetInnerHTML={{ __html: errorLabel }}
        ></div>
        </>
      )}

      {(firstLink || secondLink) && (
        <>
          {linksHeading && (
            <p className="request-a-quote__card-subheading">{linksHeading}</p>
          )}
          <ul className="request-a-quote__card-links">
            {firstLink && firstLink.href && (
              <li>
                <a href={firstLink.href} className="link link--arrow">
                  <span>{firstLink.label}</span>
                </a>
              </li>
            )}
            {secondLink && secondLink.href && (
              <li>
                <a href={secondLink.href} className="link link--arrow">
                  <span>{secondLink.label}</span>
                </a>
              </li>
            )}
          </ul>
        </>
      )}

      {phone && (
        <a
          className="btn btn--secondary request-a-quote__card-btn"
          href={`tel:${phone.trim().replace(/\D+/g, '')}`}
        >
          {phone}
        </a>
      )}
    </>
  );
};

export default Card;
